import { createReducer, on, Action } from '@ngrx/store';
import { ISiteRedinessMatrix, ISiteRequestDetails, ISiteRequestProxyMembers, ISiteRequestProxyDetails } from 'src/app/feature/site-rediness-matrix/models/request';
import * as SiteRequestAction from './site-request.action';
import * as fromSiteRequest from './site-request.adapter';
import * as fromSiteApprovals from './site-approvals.adapter';

export const initialState: ISiteRedinessMatrix = {
};

const reducer = createReducer(
  initialState,
  on(SiteRequestAction.SaveFacilityDetailsAction, (state, { data }) => state = data)
);

export function SiteRequestReducer(state: ISiteRedinessMatrix | undefined, action: Action) {
  return reducer(state, action);
}


export const init: ISiteRequestDetails = {
};

const requestDetailsReducer = createReducer(
  initialState,
  on(SiteRequestAction.saveApprovedRequestDetailsAction, (state, { data }) => state = data)
);

export function ApprovedRequestDetailsReducer(state: ISiteRequestDetails | undefined, action: Action) {
  return requestDetailsReducer(state, action);
}

const siteRequestsReducer = createReducer(fromSiteRequest.intialSiteRequestsState,
  on(SiteRequestAction.SucessGetSiteRequestsApiAction, (state, { data }) => {
    if (data.payload !== undefined && data.payload.requests !== undefined) {
      return fromSiteRequest.SiteRequestsAdapter.setAll(data.payload.requests, state);
    } else if (data.message !== undefined && data.payload === undefined) {
      return { ...state, message: data.message };
    } else {
      return fromSiteRequest.SiteRequestsAdapter.setAll([], state);
    }
  }),
  on(SiteRequestAction.SucessGetSiteRequestsApiAction, (state, { data }) => {
    return { ...state, isLoaded: true };
  }),
  on(SiteRequestAction.UpdateSiteRequestSelectedIdAction, (state, { id }) => {
    return { ...state, selectedItemId: id };
  }));

export function SiteRequestsReducer(state: fromSiteRequest.SiteRequestRequestsState | undefined, action: Action) {
  return siteRequestsReducer(state, action);
}
const siteRequestsApprovalsReducer = createReducer(fromSiteApprovals.intialSiteRequestApprovalsState,
  on(SiteRequestAction.SucessGetSiteRequestsApiAction, (state, { data }) => {
    if (data.payload !== undefined && data.payload.approvals !== undefined) {
      return fromSiteApprovals.SiteRequestApprovalsAdapter.setAll(data.payload.approvals, state);
    } else if (data.message !== undefined && data.payload === undefined) {
      return { ...state, message: data.message };
    } else {
      return fromSiteApprovals.SiteRequestApprovalsAdapter.setAll([], state);
    }
  }), on(SiteRequestAction.SucessGetSiteRequestsApiAction, (state, { data }) => {
    return { ...state, isLoaded: true };
  }),
  on(SiteRequestAction.UpdateSiteApprovalSelectedIdAction, (state, { id }) => {
    return { ...state, selectedItemId: id };
  }));


export function SiteRequestsApprovalsReducer(state: fromSiteApprovals.SiteRequestApprovalsState | undefined, action: Action) {
  return siteRequestsApprovalsReducer(state, action);
}


const proxyRequestMembersReducer = createReducer(
  [],
  on(SiteRequestAction.UpdateProxyRequestMembersAction, (state: ISiteRequestProxyMembers[], { data }) => {
    const obj = [...state, ...data];
    return state = obj.filter((item, i, arr) => arr.findIndex(t => t?.name === item?.name) === i);

  }),
  on(SiteRequestAction.DeleteProxyRequestMembersAction, (state: ISiteRequestProxyMembers[], { alias, phone }) => {
    let obj;
    if (alias === undefined) {
      obj = state.filter(member => member.phone !== phone);
    } else {
      obj = state.filter(member => member.alias !== alias);
    }
    return state = obj;
  }),
  on(SiteRequestAction.ClearProxyRequestMembersAction, (state: ISiteRequestProxyMembers[], { }) => {
    return state = [];
  }),

);

export function ProxyRequestMembersReducer(state: ISiteRequestProxyMembers[] | undefined, action: Action) {
  return proxyRequestMembersReducer(state, action);
}

const siteRequestProxyDetailsReducer = createReducer(
  {},
  on(SiteRequestAction.UpdateSiteRequestProxyDetailsAction, (state, { data }) => state = data),
  on(SiteRequestAction.ClearSiteRequestProxyDetailsAction, (state: ISiteRequestProxyDetails, { }) => {
    return state = {};
  }),
);

export function SiteRequestProxyDetailsReducer(state: ISiteRequestProxyDetails | undefined, action: Action) {
  return siteRequestProxyDetailsReducer(state, action);
}


